import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentGql } from './WorkbooksDisplayGridRowDataFragmentGql';

export const DatasourceDownstreamWorkbooksQueryGql: DocumentNode = gql`
query DatasourceDownstreamWorkbooksQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragment
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentGql}
`;
